import React from 'react';
import { CtaButton } from './CtaButton';
export function ClosingSection() {
  return <section className="bg-ink py-20 text-cream md:py-28" data-id="element-29" data-mp="otc68uht4swj">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-30" data-mp="oux2cojrsjwi">
        <h2 className="font-serif text-4xl font-semibold leading-tight text-gold-light md:text-6xl" data-id="element-31" data-mp="12twptsvjqsr3">
          Tu momento con Dios puede empezar hoy
        </h2>
        <p className="mt-8 text-lg leading-relaxed text-cream/80" data-id="element-32" data-mp="1cr1djx51iwa0">
          A veces buscamos respuestas en medio del ruido, cuando lo que necesitamos es detenernos un instante.
        </p>
        <p className="mx-auto mt-8 max-w-xl font-serif text-2xl italic leading-relaxed text-cream md:text-3xl" data-id="element-33" data-mp="17q3wjnvro8a3">
          Abrí la Biblia. Leé con calma. Reflexioná sobre cada palabra. Hacé una oración desde el corazón.
        </p>
        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-lg leading-relaxed text-cream/80" data-id="element-34" data-mp="1vgzja6ld8dah">
          <p data-id="element-35" data-mp="1qiy25r7i2o1n">Permitite construir, paso a paso, una relación más consciente con tu fe.</p>
          <p data-id="element-36" data-mp="22cm02kljtmbg">
            El Poder de los Salmos puede acompañarte en ese camino con recursos digitales que vas a poder consultar a tu
            propio ritmo.
          </p>
          <p className="text-cream" data-id="element-37" data-mp="27da0txzkxhiv">
            No hace falta empezar con grandes cambios. Empezá dedicando unos minutos a lo que realmente importa para vos.
          </p>
        </div>
        <div className="mt-10" data-id="element-38" data-mp="2ga0te0exae8p">
          <CtaButton variant="light" size="lg" data-id="element-39" data-mp="2lbhrjo60vmll">
            Quiero descubrir el poder de los Salmos
          </CtaButton>
        </div>
      </div>
    </section>;
}